import { useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons'
import { trans } from '../i18n/translate'
import * as S from './MobileSidebarChrome.styles'

export { HUB_SIDEBAR_MOBILE_BREAKPOINT, InnerPageRoot } from './MobileSidebarChrome.styles'
export { HUB_SIDEBAR_MOBILE_BREAKPOINT_PX } from '../constants/breakpoints'

export interface MobileSidebarChromeProps {
  isOpen: boolean
  onClose: () => void
  /** When false, only backdrop is rendered (e.g. Itabirito header already hosts the hamburger). */
  showCloseButton?: boolean
}

/**
 * Backdrop + optional close control for an off-canvas mobile sidebar drawer.
 * Hub tenants (Zing / WL / Itabirito) use the icon-rail collapse instead; kept for Teia
 * or future drawer-mode layouts that pair with PageTop's onMobileMenuToggle.
 */
export const MobileSidebarChrome = ({
  isOpen,
  onClose,
  showCloseButton = true,
}: MobileSidebarChromeProps) => {
  useEffect(() => {
    if (!isOpen) return undefined

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [isOpen, onClose])

  return (
    <>
      <S.SidebarBackdrop
        $visible={isOpen}
        onClick={onClose}
        role="presentation"
        aria-hidden={!isOpen}
      />
      {showCloseButton ? (
        <S.MobileSidebarCloseBar $open={isOpen}>
          <S.MobileSidebarCloseButton
            type="button"
            onClick={onClose}
            aria-label={trans('Fechar menu')}
            aria-hidden={!isOpen}
            tabIndex={isOpen ? 0 : -1}
          >
            <FontAwesomeIcon icon={faTimes} />
          </S.MobileSidebarCloseButton>
        </S.MobileSidebarCloseBar>
      ) : null}
    </>
  )
}

export const MobileMenuHamburger = ({
  isOpen,
  onToggle,
  color,
}: {
  isOpen: boolean
  onToggle: () => void
  color?: string
}) => (
  <S.MobileHamburger
    type="button"
    onClick={onToggle}
    aria-label={isOpen ? trans('Fechar menu') : trans('Abrir menu')}
    aria-expanded={isOpen}
    $color={color}
  >
    <FontAwesomeIcon icon={faBars} />
  </S.MobileHamburger>
)
